import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ResidentialHero from './components/ResidentialHero';
import ResidentialServices from './components/ResidentialServices';
import ResidentialCTA from './components/ResidentialCTA';

const ResidentialServicesPage = () => {
  useEffect(() => {
    document.title = 'Residential Electrical Services Perth | NS Electrical WA';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <ResidentialHero />
        <ResidentialServices />
        <ResidentialCTA />
      </main>
      <Footer />
    </div>
  );
};

export default ResidentialServicesPage;